import React, {Component, ReactNode, MouseEvent} from 'react';
import {inject, observer} from 'mobx-react';
import {SmileStore} from 'app/store/smile_store';
import {ScreenStore} from 'app/store/ScreenStore';
import {ChatStore} from 'app/store/ChatStore';
import {artifactStore} from 'app/store/global';
import {checkElementCookies, getLinkPath, isGuest, isDesktop, userSignedIn, setElementCookies,
    placeCaretAtEnd} from 'app/utils';
import {fetchMessages, cyrillic, MAX_TEXT_LENGTH, hideChatActions} from 'app/components/chat/chat_utils';
import {Link} from 'react-router-dom';
import {addGaEvent} from 'app/ga_methods';
// @ts-ignore
import doubleArrDownSvg from 'images/svg_icons/double-arr-down.svg';
import SliderContainer from 'app/components/slider_container';
import ChatMessages from 'app/components/chat/ChatMessages';
import I18n from 'app/i18n';
import $ from 'jquery';
import {appendToChatFromBuffer} from 'app/utils/share_to_chat';
import isEqual from 'lodash/isEqual';
import SmileMenu from './SmileMenu';
import {DivWithReference} from 'app/utils/DivWithReference';
import BarLoginMobile from 'app/components/auth/BarLoginMobile';
import ChatSelectTab from './ChatSelectTab';
import logoLink from 'site_version/com/logoLink';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {toastError} from 'app/components/toasts/liteToast';
import {KEY_ENTER} from 'app/utils/Consts';

interface ChatProps {
    chatStore?: ChatStore,
    smileStore?: SmileStore,
    screenStore?: ScreenStore,
    mobile?: boolean,
    fullScreen?: boolean
}

interface ChatState {
    height: string,
    opened: boolean,
    scrollDown: boolean,
    smileListOpened: boolean,
    isRecentSmilesLoading: boolean,
    isReplying: boolean,
    replyId: number
}

interface ImageInterface {
    name: string
    message: string
}

interface SmileResponse {
    images: ImageInterface[]
}

@inject('screenStore', 'smileStore', 'chatStore')
@observer
export default class Chat extends Component<ChatProps, ChatState> {
    constructor(props: ChatProps) {
        super(props);
        this.state = {
            height: '500px',
            isRecentSmilesLoading: false,
            isReplying: false,
            opened: checkElementCookies('chat-menu'),
            replyId: 0,
            scrollDown: false,
            smileListOpened: false
        };
        this.props.smileStore.loadSmiles();
        this.props.chatStore.subcribeChannel();
    }

    container = React.createRef();

    smileList: React.RefObject<HTMLDivElement> = React.createRef();

    messageReply: React.RefObject<HTMLDivElement> = React.createRef();

    messageInput: React.RefObject<HTMLDivElement> = React.createRef();

    componentDidMount(): void {
        $('body').on('click', this.hideChatActions);
        appendToChatFromBuffer();
    }

    componentWillUnmount(): void {
        $('body').off('click', this.hideChatActions);
        this.props.chatStore.unsubcribeChannel();
    }

    hideChatActions = (e: MouseEvent): void => {
        const target = e.target as HTMLElement;

        if (
            !target.closest('.chat__actions') &&
            !target.closest('.chat__smile-list') &&
            !target.closest('.button-clear-smileys')
        ) {
            hideChatActions();
        }

        if (
            !target.closest('.chat__input-smile') &&
            !target.closest('.chat__smile-list') &&
            !target.closest('.button-clear-smileys')
        ) {
            this.smilesListSlideUp();
        }
    };

    updateHeight = (): void => {
        this.setState({height: `${window.innerHeight - $('.header').height() - $('.tap_bar').height()}px`});
    };

    onlineElement(): ReactNode {
        return <span className="chat__counter">({this.props.chatStore.online} {I18n.t('chat_online')})</span>;
    }

    scrollToBottom = (): void => {
        this.setState({scrollDown: true}, () => {
            this.setState({scrollDown: false});
        });
    };

    openChat = (): void => {
        const opened = !this.state.opened;
        this.setState({opened});
        addGaEvent('Chat', opened ? 'closed' : 'opened');
        setElementCookies('chat-menu', opened);
    };

    placeCaretAtEnd = (): void => {
        placeCaretAtEnd($(this.messageInput.current).get(0));
    };

    insertUserName = (id: number, name: string, message: string): void => {
        this.setState({isReplying: true, replyId: id});
        $(this.messageInput.current).text('');
        $(this.messageReply.current).html(`<p><span>${I18n.t('message_reply')}</span> <b>${name}</b></p><div>${message}</div>`);
        this.placeCaretAtEnd();
    };

    insertUserNameNick = (name: string): void => {
        this.setState({isReplying: false});
        $(this.messageInput.current).text(`\u200B${name}\u200E,\xa0`);
        this.placeCaretAtEnd();
    };

    selectRuTabByMessage = (message: string): boolean => this.props.chatStore.currentLang !== 'ru' && cyrillic(message);

    sendMessage = (): void => {
        $(this.smileList.current).slideUp();
        const element = $(this.messageInput.current);
        const textMessage = element.text();

        if (!textMessage || this.props.chatStore.disabledButton) {
            return;
        }

        const {isReplying, replyId} = this.state;
        const replyMessage = isReplying && `:re-${replyId}:`;
        const textMessageLength = textMessage.length + (replyMessage ? replyMessage.length : 0);

        if (textMessageLength > MAX_TEXT_LENGTH + 1) {
            toastError(I18n.t('text_size_exceeds_limit'));
            return;
        }

        this.props.chatStore.sendMessage(this.selectRuTabByMessage(textMessage),
            this.scrollToBottom,
            this.messageInput.current,
            replyMessage);

        this.setState({isReplying: false});
    };

    sendMessageHandle = (e: React.SyntheticEvent): void => {
        e.preventDefault();
        this.sendMessage();
    };

    handlerKeyPress = (e: React.KeyboardEvent<HTMLDivElement>): void => {
        if (e.key === KEY_ENTER) {
            this.sendMessage();
            e.preventDefault();
        }

        const {isReplying, replyId} = this.state;
        const replyMessage = isReplying && `:re-${replyId}:`;
        const textMessageLength =
            (this.messageInput.current?.textContent?.length ?? 0) +
            (replyMessage?.length ?? 0);

        if ((textMessageLength > MAX_TEXT_LENGTH || this.props.chatStore.disabledButton) && e.key !== 'Backspace') {
            e.preventDefault();
        }
    };

    inputMouseDownHandler = (): void => {
        if ($(this.messageInput.current).is(':focus')) {
            return;
        }
        this.placeCaretAtEnd();
    };

    closeReply = (): void => {
        this.setState({isReplying: false});
    };

    updateRecentSmiles = (response: SmileResponse): void => {
        const {smileStore} = this.props;

        if (!isEqual(smileStore.recent_smiles, response)) {
            const TIMEOUT = 400;
            this.setState(
                {isRecentSmilesLoading: true},
                () => setTimeout(() => {
                    this.setState({isRecentSmilesLoading: false}, () => smileStore.updateRecentSmiles(response));
                }, TIMEOUT)
            );
        }
    };

    smilesListSlideUp = (): void => {
        $(this.smileList.current).slideUp('done', () => {
            this.setState({smileListOpened: false});
        });
    };

    openSmilesList = (e: React.MouseEvent): void => {
        e.preventDefault();
        if (this.state.smileListOpened) {
            this.smilesListSlideUp();
        } else {
            this.setState({smileListOpened: true}, () => {
                $(this.smileList.current).slideDown(
                    'done',
                    () => this.props.smileStore.loadRecentSmiles(this.updateRecentSmiles)
                );
            });
        }
    };

    insertSmile = (smile: string): void => {
        const textInput = $(this.messageInput.current);
        const smile_name = smile.substring(0, smile.lastIndexOf('.'));

        if (smile_name.length + textInput.text().length <= MAX_TEXT_LENGTH) {
            textInput.text(`${textInput.text()} :${smile_name}:`);
        }
        this.placeCaretAtEnd();
        this.smilesListSlideUp();
    };

    render(): ReactNode {
        const {langs, currentLang} = this.props.chatStore;
        const {fullScreen, mobile, smileStore} = this.props;
        const {opened, smileListOpened, isRecentSmilesLoading, scrollDown, isReplying} = this.state;
        return <div className={`chat${fullScreen ? ' chat--fullscreen' : ''} ${mobile ? 'chat--mobile' : ''}`}>
            <div className="chat__inner">
                <div id="block-user"/>
                <div id="block-list"/>
                <div className="chat__heading">
                    {fullScreen
                        ? <>
                            <div className="chat__title" key="chat__title">
                                <h1 className="chat__title-text">{I18n.t('chat_title')}</h1>
                                {this.onlineElement()}
                            </div>
                            <div className="chat__logo" key="chat__logo">
                                {logoLink && logoLink()}
                            </div>
                        </>
                        : <div className="chat__title">
                            <div className="chat__title-row">
                                {mobile
                                    ? <h1 className="chat__title-text">{I18n.t('chat_title')}</h1>
                                    : <h3 className="chat__title-text">{I18n.t('chat_title')}</h3>}
                                <Link
                                    to={getLinkPath('/chat')}
                                    target="_blank"
                                    className="chat__title-icon"
                                >
                                    <SpriteIcon name={'#svg-maximize'} size={{height: 22, width: 22}}/>
                                </Link>
                            </div>
                            {this.onlineElement()}
                        </div>}
                    <div className="chat__controls">
                        <div className={`chat__lang-switcher${opened || fullScreen || mobile ? '' : ' hidden'}`}>
                            {langs.length > 1
                                ? langs.map(lang => <ChatSelectTab key={`tab-${lang}`} lang={lang}
                                    chatStore={this.props.chatStore}/>)
                                : null}
                        </div>
                        {fullScreen || mobile
                            ? null
                            : <button
                                data-js-opener="chat-menu"
                                onClick={this.openChat}
                                className={`act chat__opener${opened ? ' opener-active' : ''}`}
                            >
                                <img src={doubleArrDownSvg} alt="opener" height="12px" width="12px"/>
                            </button>}
                    </div>
                </div>
                <SliderContainer opened={fullScreen || mobile ? true : opened}>
                    <div className="chat__content">
                        <div className="chat__message-list custom-scroll-shadow has-shadow">
                            <ChatMessages
                                messages={fetchMessages(this.props.chatStore)}
                                fullScreen={fullScreen}
                                currentLang={currentLang}
                                insertUserName={this.insertUserName}
                                insertUserNameNick={this.insertUserNameNick}
                                scrollDown={scrollDown}
                                clearReply={this.closeReply}
                            />
                        </div>
                        {userSignedIn() &&
                        <>
                            <div className={`chat__reply-content${isReplying ? ' active' : ''}`}>
                                <SpriteIcon className="svg-default svg-reply" name={'#svg-chat-reply'}/>
                                <div className="chat__reply-text" ref={this.messageReply}/>
                                <button className="chat__reply-close" onClick={this.closeReply}>
                                    <SpriteIcon className="svg-default svg-close" name="#svg-close"/>
                                </button>
                            </div>
                            <form className="chat__message-add" onSubmit={this.sendMessageHandle}>
                                <div
                                    onKeyDown={this.handlerKeyPress}
                                    onMouseDown={this.inputMouseDownHandler}
                                    className="chat__input-text js-chat-input"
                                    data-placeholder={`${I18n.t('please_enter_you_message')}...`}
                                    contentEditable="true"
                                    ref={this.messageInput}
                                />
                                <div className="chat__input-smile">
                                    <a className="act chat__smile-opener" onClick={this.openSmilesList}>
                                        <SpriteIcon name={'#svg-smile'} size={{height: 22, width: 22}}/>
                                    </a>
                                </div>
                                <button className="act chat__submit">
                                    <SpriteIcon name={'#svg-send'} size={{height: 12, width: 10}}/>
                                </button>
                            </form>
                        </>}
                    </div>
                </SliderContainer>
                {!isDesktop() && isGuest() && <BarLoginMobile/>}
                {smileListOpened && <DivWithReference ref={this.smileList} className={'chat__smile-list js-smile-list'}>
                    <SmileMenu
                        smiles={artifactStore.smileFilenames.concat(smileStore.smiles)}
                        insertSmile={this.insertSmile}
                        recent_smiles={smileStore.recent_smiles}
                        isLoading={isRecentSmilesLoading}/>
                </DivWithReference>}
            </div>
        </div>;
    }
}
